import { useDispatch } from 'react-redux'
import { actions } from '../../../../RestockingState'
import { RestockingState } from 'src/features/restocking/RestockingTypes'
import { useHistory } from 'react-router-dom'
import Content from '../Content/Content'
import theme from 'src/styles/theme'
import * as S from './AnswerOptions.styles'

interface ButtonProps {
  color: keyof typeof theme.colors;
  hoverColor: keyof typeof theme.colors;
  value: boolean | number;
  text: string;
  testid: string;
}

interface AnswerOptionsProps {
  text: string;
  property: keyof RestockingState,
  nextPage: string;
  firstButtonProps: ButtonProps;
  secondButtonProps: ButtonProps;
}

const AnswerOptions: React.FC<AnswerOptionsProps> = ({
  text,
  property,
  nextPage,
  firstButtonProps,
  secondButtonProps,
}) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const setValue = (value: boolean | number) => {
    dispatch(actions.setProperty({ property, value }))
    history.push(nextPage)
  }

  return (
    <Content text={text}>
      <S.ContainerButtons>
        <S.CustomButton
          title={firstButtonProps.text}
          bgColor={firstButtonProps.color}
          hoverColor={firstButtonProps.hoverColor}
          letterColor='white'
          data-testid={firstButtonProps.testid}
          onClick={() => setValue(firstButtonProps.value)}
        />
        <S.CustomButton
          title={secondButtonProps.text}
          bgColor={secondButtonProps.color}
          hoverColor={secondButtonProps.hoverColor}
          letterColor='white'
          data-testid={secondButtonProps.testid}
          onClick={() => setValue(secondButtonProps.value)}
        />
      </S.ContainerButtons>
    </Content>
  )
}

export default AnswerOptions
